import { render } from "./FRM_Evangelios.vue?vue&type=template&id=246c7bde"
import script from "./FRM_Evangelios.vue?vue&type=script&lang=js"
export * from "./FRM_Evangelios.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\evangelio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__